import ImagePlaceholder from "@/components/base/ImagePlaceholder";

const moteurs = [
  "Moteur Somfy io (fil pilote, compatible box domotique)",
  "Moteur Somfy RTS (radio, télécommande murale ou portable)",
  "Moteur Somfy filaire (interrupteur mural classique)",
  "Moteur avec manœuvre de secours en cas de coupure",
  "Moteur adapté au poids et à la dimension du tablier",
  "Moteur silencieux pour chambre ou pièce de vie",
];

export default function QuelMoteur() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="order-2 lg:order-1">
            <h2 className="text-[#143A66] text-2xl md:text-3xl font-extrabold mb-5">
              Quel moteur choisir en remplacement
            </h2>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-5">
              Le choix du moteur de remplacement dépend de votre système de commande actuel et de vos besoins. Si vous disposez déjà d'une télécommande Somfy io ou d'une box domotique, nous vous proposons un moteur compatible io pour conserver toutes vos automations. Si vous utilisez une télécommande RTS ou un interrupteur radio, nous installons un moteur RTS avec une reprogrammation complète de vos points de commande.
            </p>
            <p className="text-[#2F4A63] text-base leading-relaxed mb-6">
              Pour les installations filaires, nous proposons des moteurs Somfy classiques avec interrupteur mural. Nous prenons aussi en compte le poids de votre tablier et la dimension du volet pour choisir un moteur avec le couple adapté. Si vous souhaitez améliorer le confort, nous proposons des versions silencieuses ou avec manœuvre de secours pour les zones de coupure de courant fréquentes.
            </p>
            <ul className="space-y-3 mb-8">
              {moteurs.map((moteur) => (
                <li key={moteur} className="flex items-center gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-[#00B3A4]/10 shrink-0">
                    <i className="ri-check-line text-[#00B3A4] text-sm"></i>
                  </span>
                  <span className="text-[#143A66] text-base font-medium">{moteur}</span>
                </li>
              ))}
            </ul>
            <a
              href="tel:0374473240"
              className="flex items-center gap-2 bg-[#00B3A4] text-white px-6 py-4 rounded-lg font-semibold text-base hover:bg-[#00B3A4]/90 transition-colors whitespace-nowrap mx-auto"
            >
              <i className="ri-phone-line text-lg"></i>
              Appeler le 03 74 47 32 40
            </a>
          </div>
          <div className="order-1 lg:order-2 relative rounded-xl overflow-hidden border border-[#E2E8F0]">
            <ImagePlaceholder
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/16c2f1e09238926485a84a0f738ffb01.jpeg"
              alt="Choix du moteur Somfy pour remplacement de volet roulant à Strasbourg"
              className="w-full h-[340px] md:h-[420px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}